import i18n from 'i18next';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole } from 'globalutils/fmUtils';

export const columns = [
  {
    id: 'description',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.description'),
    needSorting: window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? false : true,
  },
  {
    id: 'driver',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.driverName'),
    needSorting: window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? false : true,
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.date'),
    needSorting: window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? false : true,
  },
  {
    id: 'vehicle',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.vehicle'),
    needSorting: window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? false : true,
  },

  {
    id: 'phone',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.driverPhone'),
    needSorting: window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? false : true,
  },

  ...(!hasRestrictedRole([ROLES.VIEW_ONLY_FM])
    ? [
        {
          id: 'actions',
          label: 'common.delete',
        },
      ]
    : []),
];
